import React from "react";

const Contact = () => {
  const contactLocations = [
    {
      id: 1,
      city: "Richmond, London",
      address: "123 Tech Park, Richmond",
      location: "Dist. Greater London, United Kingdom",
      phone: "+01 12345 67890",
      email: "info@company.com",
      map: "https://maps.google.com/maps?q=Richmond%20London&t=&z=13&ie=UTF8&iwloc=&output=embed"
    },
    {
      id: 2,
      city: "Fremont, Alameda",
      address: "789 Innovation Drive, Fremont",
      location: "Dist. Alameda, California, USA - 94538",
      phone: "+01 98765 43210",
      email: "company@gmail.com",
      map: "https://maps.google.com/maps?q=Fremont%20California&t=&z=13&ie=UTF8&iwloc=&output=embed"
    }
  ];

  return (
    <>
      <style>{`
        .contact-container {
          padding: 40px 20px;
          background: #f8f9fa;
          min-height: 100vh;
          font-family: Arial, sans-serif;
        }

        .contact-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .contact-title {
          font-size: 42px;
          font-weight: bold;
          color: #333;
          margin-bottom: 15px;
        }

        .contact-subtitle {
          font-size: 18px;
          color: #666;
          max-width: 600px;
          margin: 0 auto;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
          gap: 40px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .contact-card {
          background: white;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: transform 0.3s ease;
        }

        .contact-card:hover {
          transform: translateY(-5px);
        }

        .contact-map {
          height: 300px;
          position: relative;
        }

        .contact-map iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }

        .contact-info {
          padding: 30px;
        }

        .contact-city {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
        }

        .contact-city::before {
          content: "📍";
          margin-right: 10px;
          font-size: 20px;
        }

        .contact-details {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .contact-detail {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          color: #555;
        }

        .contact-detail-icon {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
          border-radius: 50%;
          font-size: 12px;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .contact-detail-text {
          line-height: 1.5;
        }

        .contact-detail-label {
          font-weight: 600;
          color: #333;
          margin-bottom: 2px;
        }

        .contact-form-section {
          max-width: 800px;
          margin: 60px auto 0;
          background: white;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }

        .contact-form-title {
          font-size: 28px;
          font-weight: bold;
          color: #333;
          margin-bottom: 30px;
          text-align: center;
        }

        .contact-form {
          display: grid;
          gap: 20px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group.full-width {
          grid-column: 1 / -1;
        }

        .form-label {
          margin-bottom: 8px;
          font-weight: 600;
          color: #333;
        }

        .form-input,
        .form-textarea {
          padding: 12px 15px;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          font-size: 14px;
          transition: border-color 0.3s ease;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #667eea;
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
        }

        .form-submit {
          padding: 15px 40px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
          border: none;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          justify-self: center;
        }

        .form-submit:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
        }

        .contact-info-section {
          max-width: 1200px;
          margin: 60px auto 0;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 30px;
        }

        .info-card {
          background: white;
          padding: 30px;
          border-radius: 15px;
          text-align: center;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
        }

        .info-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          font-size: 24px;
          color: white;
        }

        .info-title {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }

        .info-text {
          color: #666;
          line-height: 1.6;
        }

        @media (max-width: 768px) {
          .contact-title {
            font-size: 32px;
          }
          
          .contact-grid {
            grid-template-columns: 1fr;
          }
          
          .form-row {
            grid-template-columns: 1fr;
          }
          
          .contact-form-section {
            padding: 30px 20px;
          }
        }
      `}</style>

      <div className="contact-container">
        <div className="contact-info-section">
          <div className="info-card">
            <div className="info-icon">🕐</div>
            <h3 className="info-title">Business Hours</h3>
            <p className="info-text">
              Monday - Friday: 8:00 AM - 6:00 PM<br />
              Saturday: 9:00 AM - 4:00 PM<br />
              Sunday: Closed
            </p>
          </div>
          <div className="info-card">
            <div className="info-icon">🚚</div>
            <h3 className="info-title">Delivery Service</h3>
            <p className="info-text">
              24/7 emergency delivery available<br />
              Same-day delivery for orders placed before 12 PM
            </p>
          </div>
          <div className="info-card">
            <div className="info-icon">🏆</div>
            <h3 className="info-title">Quality Guarantee</h3>
            <p className="info-text">
              All our concrete meets industry standards<br />
              100% satisfaction guaranteed
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
